export default {
  addFileBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    rowGap: '.5rem',
    backgroundColor: 'bg.light',
    border: '1px dashed #E7EDF6',
    mt: '1.2rem',
    p: '11.5px'
    // "opacity": (isDisabled || row?.files?.length === 5) ? ".65" : 1,
    // "outline": errors?.[idx]?.length > 0 ? "1px solid red" : "0",
  }
};
